export default "__VITE_ASSET__Cl2SYpQ5__"